// Simple fix for ADA viewport issue caused by third-party apps
(function() {
  function fixViewports() {
    // Remove any viewport meta tags that are not in the head
    document.querySelectorAll('body meta[name="viewport"]').forEach(tag => tag.remove());
    
    // Remove any viewport meta tags with user-scalable=0 or maximum-scale<5
    document.querySelectorAll('meta[name="viewport"]').forEach(tag => {
      const content = tag.content.toLowerCase();
      if (content.includes('user-scalable=0') || 
          content.includes('user-scalable=no') ||
          /maximum-scale=[0-4]/.test(content)) {
        tag.remove();
      }
    });
  }

  function fixIframeTitles() {
    // Find all iframes without a title attribute
    document.querySelectorAll('iframe:not([title])').forEach(iframe => {
      // Check if it's from a form builder or common app
      const src = iframe.src || '';
      let title = 'Embedded Content';
      
      if (src.includes('123formbuilder.com')) {
        title = 'Contact Form';
      } else if (src.includes('form')) {
        title = 'Form';
      } else if (src.includes('chat')) {
        title = 'Chat Widget';
      } else if (src.includes('review')) {
        title = 'Reviews Widget';
      } else if (src.includes('map')) {
        title = 'Map';
      } else if (src.includes('video') || src.includes('youtube') || src.includes('vimeo')) {
        title = 'Video Player';
      } else if (src.includes('social')) {
        title = 'Social Media Widget';
      }
      
      iframe.setAttribute('title', title);
    });

    // Also fix iframes with empty titles
    document.querySelectorAll('iframe[title=""]').forEach(iframe => {
      const src = iframe.src || '';
      let title = 'Embedded Content';
      
      if (src.includes('123formbuilder.com')) {
        title = 'Contact Form';
      } else if (src.includes('form')) {
        title = 'Form';
      }
      
      iframe.setAttribute('title', title);
    });
  }

  // Run on page load and periodically
  document.addEventListener('DOMContentLoaded', function() {
    fixViewports();
    fixIframeTitles();
  });
  
  setInterval(function() {
    fixViewports();
    fixIframeTitles();
  }, 2000);
})(); 